<template>
  <div class="container-fluid w-100 h-100 d-flex justify-content-center align-items-center">
    <div class="animated fadeIn w-100 h-100">
      <div class="cards-container w-100 h-100" style="padding: 30px">
        <HomeCard
          v-for="card in cards"
          :key="card.id"
          :route="card.route"
          :icons="card.icons"
          :header="card.header"
          :content="card.content"
          :active="card.active"
          :placeholder="card.placeholder"
        />
      </div>
    </div>
    <img class="logo" :src="logo"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import HomeCard from '../components/Home/HomeCard'
import usersActions from '../store/modules/users/actionTypes'
import studiesActions from '../store/modules/studies/actionTypes'
import studiesGetters from '../store/modules/studies/getterTypes'
import logo from '../assets/images/logos/Final-Logo-Iris-04-03.png'
import generalGetters from '../store/modules/general/getterTypes'

export default {
  name: 'home',
  components: { HomeCard },
  async created () {
    await this.getRoles()
    await this.getFields()
  },
  data: () => ({
    logo
  }),
  computed: {
    ...mapGetters({
      studyCount: studiesGetters.GET_STUDY_COUNT,
      userPermissions: generalGetters.GET_PERMISSIONS
    }),
    cards () {
      let cardList = [
        {
          id: 1,
          route: 'search',
          icons: [{ name: ['fa', 'search'] }],
          header: 'Search for Study',
          content: 'Explore studies, results and study material.',
          active: true
        },
        {
          id: 2,
          route: 'topworst',
          icons: [{ name: ['fa', 'trophy'] }],
          header: 'Best/Worst Testers',
          content: 'Based on consumer hedonic scores.',
          active: true
        },
        {
          id: 4,
          route: 'attributes',
          icons: [{ name: ['fa', 'share-alt'] }],
          header: 'Fragrance Profile',
          content: 'Understand which fragrances are perceived as <i>Clean, Relaxing, Good for every day use,</i> etc.',
          active: true
        },
        {
          id: 5,
          route: 'category-profile',
          icons: [{ name: ['fa', 'arrows-alt'], rotation: 45 }],
          header: 'Category Profile',
          content: 'Understand how consumers view a category.',
          active: true
        },
        {
          id: 6,
          route: 'group-comparison',
          icons: [{ name: ['fa', 'address-card'] }, { name: ['fa', 'address-card'] }],
          header: 'Group Comparison',
          content: 'Compare two groups (fragrances, business units, etc.) to each other.',
          active: true
        }
      ]
      if (this.userPermissions.isAdmin || this.userPermissions.canAccessAnalytics) {
        cardList = [...cardList,
          {
            id: 7,
            route: 'analytics',
            icons: [{ name: ['fa', 'vial'] }],
            header: 'Advanced Analytics',
            content: 'I work in CMI and want to run customized analytics.',
            active: true
          },
          {
            id: 8,
            route: 'cics',
            icons: [{ name: ['fa', 'user'] }],
            header: 'CICS',
            content: 'I want to search CICS data.',
            active: true
          },
          {
            id: 10,
            route: 'studies-upload',
            icons: [{ name: ['fa', 'cloud-upload-alt'] }],
            header: 'Studies Upload',
            content: 'I want to upload studies files.',
            active: true
          },
          {
            id: 11,
            route: 'statistics-generator',
            icons: [{ name: ['fa', 'chart-bar'] }],
            header: 'Statistics Generator ',
            content: 'I want to generate some statistics',
            active: true
          }
        ]
      }
      return cardList
    }
  },
  methods: {
    ...mapActions({
      getFields: studiesActions.FETCH_FIELDS,
      getRoles: usersActions.FETCH_ROLES
    })
  }
}
</script>
<style lang="scss">
.logo {
  position: fixed;
  bottom: -15px;
  right: 0;
  max-width: 300px;
  min-width: 200px;
  max-height: 300px;
  min-height: 200px;
  width: 20%;
  height: 20%;
}

.cards-container {
  z-index: 2;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: row;
}

@media screen and (max-width: 940px) {
  .logo {
    bottom: 20px;
  }
}

@media screen and (min-width: 1640px) and (max-aspect-ratio: 19/8) {
  .logo {
    bottom: 31px;
    right: 0;
    width: 5%;
    min-width: 84px
  }
}
</style>
